import React, { memo } from 'react';

import Popup from '../helpers/Popup';
import Button from '../helpers/Button';

const AgreementLinkPopupComponent = ({ suggestBuyer, suggestAgreement, isDisabled, onClose }) => {
  const footer = (
    <Button key="close" disabled={isDisabled} onClick={onClose}>
      Close
    </Button>
  );

  return (
    <Popup footer={footer} header="Agreement Linking" id="addAgreementLink">
      <div className="row">
        <div className="col-sm-6">{suggestBuyer}</div>
        <div className="col-sm-6">{suggestAgreement}</div>
      </div>
    </Popup>
  );
};

export const AgreementLinkPopup = memo(AgreementLinkPopupComponent);
